// src/cert/ai.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const AI = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>कृत्रिम बुद्धिमत्ता (AI) सेवा</h1>
                <p>नैतिक, सुरक्षित आणि कार्यक्षम AI सोल्युशन्स</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>AI सेवा म्हणजे काय?</h2>
                    <p>
                        आम्ही Artificial Intelligence (AI) is changing the way we do business. Across all industries, from technology to healthcare, financial services and consumer products, organisations are adopting AI, intelligent automation and advanced analytics to improve processes, drive new business opportunities and increase competitive advantage.

                        We partner with organisations to solve business challenges with cutting-edge Artificial Intelligence services that improve speed, enhance precision, and optimise customer experiences. As companies progress on the journey toward digital transformation, AI is a key element that promises to deliver critical insights leading to accelerated innovation and success while protecting critical business assets.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>प्रक्रिया ऑटोमेशन — वेळ आणि श्रम बचत</li>
                        <li>डेटा-आधारित निर्णय — अचूकता वाढते</li>
                        <li>ग्राहक अनुभव सुधारतो (चॅटबॉट, शिफारस)</li>
                        <li>जोखीम शोध आणि फसवणूक रोखणे</li>
                        <li>नैतिक AI, गोपनीयता आणि ISO 42001 सुसंगतता</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>AI सेवा साठी अर्ज करा</h2>
                    <ApplyForm certification="Artificial Intelligence" />
                </section>
            </div>
        </div>
    );
};

export default AI;
